import { createGTMEvent } from '../../core/ecommerceMapper';
import { normalizeSegment } from '../../core/normalizers';
import type { GTMEventName } from '../../types';
import type { SurveyEventInput } from './types';

const SURVEY_EVENTS = {
    NativeSurvey: 'native_survey',
} as const satisfies Record<string, GTMEventName>;

export const createSurveyGAEvent = (input: SurveyEventInput) => {
    const { userId, surveyName, surveyAction, segment, service, surveyResponse } = input.data;

    return createGTMEvent(SURVEY_EVENTS.NativeSurvey, {
        user_id: userId,
        survey_name: surveyName,
        survey_action: surveyAction,
        segment: normalizeSegment(segment),
        service,
        survey_response: surveyResponse ?? null,
    });
};
